__turbopack_context__.v({
  "button": "TagInfoModalContent-module-scss-module__MBYgDW__button",
  "heading": "TagInfoModalContent-module-scss-module__MBYgDW__heading",
  "mainText": "TagInfoModalContent-module-scss-module__MBYgDW__mainText",
  "tag": "TagInfoModalContent-module-scss-module__MBYgDW__tag",
});
